import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export function exportAsExcelFile(data, excelFileName: string): void {
  if (data.length > 0) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    saveAsExcelFile(excelBuffer, excelFileName);
  } else {
    console.warn('No Data Found');
  }
}

function saveAsExcelFile(buffer, fileName: string): void {
  const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

  FileSaver.saveAs(
    data,
    `${fileName}_export_${new Date().toLocaleString('en-GB', {
      timeZone: 'Asia/Kolkata',
      hour12: true,
    })}${EXCEL_EXTENSION}`
  );
}
